import { createAction } from 'redux-actions';

export const constants = {
  setCompanyLoginImage: 'device.config.set_company_login_image',
  setCompanyLoginCoverImage: 'device.config.set_company_login_cover_image',
};

export const actions = Object
  .keys(constants)
  .reduce((res, key) =>
    Object.assign(res, { [key]: createAction(constants[key]) }), {});
